import { type NodeProps } from '@xyflow/react';
import { ActionTypes } from 'automations/types/automationConfig';
import { type ActionNodeType } from 'automations/types/nodeSchemas/actionNodes';

import useAddLeadActivity from './useAddLeadActivity';
import useCompleteTask from './useCompleteTask';
import useCreateTask from './useCreateTask';
import useDistributeLead from './useDistributeLead';
import useSendEmail from './useSendEmail';
import useSendWebengageEvent from './useSendWebengageEvent';
import useTriggerAiCall from './useTriggerAiCall';
import useUpdateLead from './useUpdateLead';
import useWebhook from './useWebhook';

export interface ActionNodeReturnProps {
  subTitle?: React.ReactNode;
  icon: React.FC<any>;
  hasErrors: boolean;
  errorMessages: string[];
  handleCopy?: () => void;
  AdditionalUI?: React.ReactNode;
}

export const ActionNodeConfigFactory = {
  [ActionTypes.updateLead]: useUpdateLead,
  [ActionTypes.addLeadActivity]: useAddLeadActivity,
  [ActionTypes.webhook]: useWebhook,
  [ActionTypes.sendEmail]: useSendEmail,
  [ActionTypes.createTask]: useCreateTask,
  [ActionTypes.completeTask]: useCompleteTask,
  [ActionTypes.distributeLead]: useDistributeLead,
  [ActionTypes.sendWebengageEvent]: useSendWebengageEvent,
  [ActionTypes.triggerAiCall]: useTriggerAiCall,
};

export default function useActionNodeConfig(node: NodeProps<ActionNodeType>): ActionNodeReturnProps {
  const { data: { nodeSubType } } = node;

  return ActionNodeConfigFactory[nodeSubType](node as any);
}
